import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import CustomDatePicker from "../../../components/Custom-Datepicker";
import moment from "moment";

function IncentiveMaster() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Incentive Master"));
  }, []);
  const [incentives, setincentives] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [validated, setValidated] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editedincentives, setEditedIncentives] = useState(null);
  const [formData, setFormData] = useState({
    incentive_type: "",
    percent_domestic: "",
    thresholdlimit: "",
    from_date: "",
    to_date: "",
    IsInActive: 0,
  });

  const [errors, setErrors] = useState({
    incentive_type: "",
    percent_domestic: "",
    from_date: "",
  });

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      incentive_type: "",
      percent_domestic: "",
      from_date: "",
    };

    // Validate incentive_type
    if (!formData.incentive_type.trim()) {
      newErrors.incentive_type = "Incentive Type is required";
      valid = false;
    }

    // Validate percent_domestic
    // Validate percent_domestic
    if (
      formData.percent_domestic === "" ||
      formData.percent_domestic === null
    ) {
      newErrors.percent_domestic = "Percentage is required";
      valid = false;
    } else if (isNaN(formData.percent_domestic)) {
      newErrors.percent_domestic = "Must be a number";
      valid = false;
    } else if (
      parseFloat(formData.percent_domestic) < 0 ||
      parseFloat(formData.percent_domestic) > 100
    ) {
      newErrors.percent_domestic = "Must be between 0 and 100";
      valid = false;
    }

    // Validate from_date
    if (!formData.from_date) {
      newErrors.from_date = "From Date is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };
  const columns = {
    incentive_type: { text: "Incentive Type / Label", visible: "true" },
    percent_domestic: {
      text: "Incentive Percentage",
      align: "center",
      visible: "true",
    },
    thresholdlimit: { text: "Threshold Limit", visible: "true" },
    from_date: { text: "From Date", align: "center", visible: "true" },
    to_date: { text: "To Date", align: "center", visible: "true" },
    IsInActive: { text: "Active", align: "center", visible: "true" },
  };

  useEffect(() => {
    fetchIncentive();
  }, [searchTerm]);

  useEffect(() => {
    if (!showEditModal) {
      setEditedIncentives(null);
      setFormData({
        incentive_type: "",
        percent_domestic: "",
        thresholdlimit: "",
        from_date: "",
        to_date: "",
        IsInActive: 0,
      });
    }
  }, [showEditModal]);
  const [apiStatus, setApiStatus] = useState(undefined);
  const fetchIncentive = async () => {
    setApiStatus(undefined);
    try {
      const response = await GetServiceCaller(`${API_URL}IncentiveMaster`);
      if (!response) {
        throw new Error("Failed to fetch incentives");
      }
      setApiStatus(response?.status);
      const data = response.data;
      // Format the "From Date" to DD/MM/YYYY
      const formattedIncentives = data.map((inc) => ({
        ...inc,
        from_date: inc.from_date,
      }));
      setincentives(formattedIncentives);
    } catch (error) {
      console.error("Error fetching Incentive:", error);
      toast.error("Failed to fetch Incentive. Please try again later.");
    }
  };

  const handleEdit = async(incentive) => {
    console.log('check id:::',incentive.ID);
        try {
          const response = await GetServiceCaller(
            `${API_URL}IncentiveMaster/${incentive.ID}`
          );
    
          if (response.status === 200) {
            const depData = response?.data?.data;
    
            if (depData) {
              const { Name, Code, Description, IsGroup } = depData;
              // Update form data with fetched values, including IsGroup
               setEditedIncentives(incentive);
    setFormData({
      incentive_type: incentive.incentive_type,
      percent_domestic: incentive.percent_domestic,
      thresholdlimit: incentive.thresholdlimit,
      from_date: incentive.from_date,
      to_date: incentive.to_date,
      IsInActive: incentive.IsInActive,
    });
    setShowEditModal(true);
            }
          } else {
            console.error(
              "Failed to fetch Designation details. Server responded with status:",
              response.status
            );
          }
        } catch (error) {
          console.error("Error fetching Designation details:", error);
        }
 
  };

  const handleEditModalClose = () => {
    setShowEditModal(false);
    setErrors({});
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    let val = value;

    if (type === "checkbox") {
      val = checked ? 1 : 0; // ✅ convert boolean to 1 or 0
    }

    setFormData({ ...formData, [name]: val });

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    // Proceed with form submission logic
    if (editedincentives) {
      updateIncentive();
    } else {
      createIncentive();
      toast.success("Incentive added successfully.");
    }
    setShowEditModal(false);
  };

  const createIncentive = async () => {
    const payload = {
      ...formData,
      from_date: moment(formData.from_date).format("YYYY-MM-DD"),
      to_date: moment(formData.to_date).format("YYYY-MM-DD"),
    };

    const response = await PostServiceCaller(
      `${API_URL}IncentiveMaster`,
      payload,
      "post"
    );
    if (response?.status === 200) {
      fetchIncentive();

      setTimeout(() => {
        toast.success("Data Submitted successfully");
      }, 2000);
    }
  };

  const updateIncentive = async () => {
    const payload = {
      ...formData,
      from_date: moment(formData.from_date).format("YYYY-MM-DD"),
      to_date: moment(formData.to_date).format("YYYY-MM-DD"),
    };

    const response = await PostServiceCaller(
      `${API_URL}IncentiveMaster/${editedincentives.ID}`,
      payload,
      "put"
    );
    if (response?.status === 200) {
      setTimeout(() => {
        toast.success("Data Submitted successfully");
      }, 2000);
      fetchIncentive();
    }
  };

  const handleAddNew = () => {
    setShowEditModal(true);
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={incentives}
              columns={columns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isActionRequired={true}
              showIcon1={true}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              isSorting={true}
              handleAddNew={handleAddNew}
              handleIcon1={handleEdit}
              isAddNewBtnRequired={true}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
              }}
            />
            <Modal
              show={showEditModal}
              onHide={handleEditModalClose}
              dialogClassName="modal-lg"
              centered
            >
              <div className="modal-content" style={{ borderRadius: "8px" }}>
                <div
                  className="modal-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #f0f0f0",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px 8px 0 0",
                    padding: "12px 16px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "20px",
                      fontWeight: "600",
                      color: "#27568B",
                      margin: "0",
                    }}
                  >
                    {editedincentives ? "Edit Incentive" : "Add Incentive"}
                  </p>
                  <button
                    onClick={handleEditModalClose}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "18px",
                      color: "#000",
                      padding: "4px",
                      borderRadius: "4px",
                      transition: "all 0.2s",
                      lineHeight: "1",
                    }}
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>

                <Modal.Body style={{ padding: "16px" }}>
                  <Form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label htmlFor="Code" className="form-label">
                            Incentive Type<span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            name="incentive_type"
                            value={formData.incentive_type}
                            className={`form-control ${
                              errors.incentive_type ? "is-invalid" : ""
                            }`}
                            onChange={handleInputChange}
                            style={{ padding: "8px 12px", borderRadius: "4px" }}
                          />
                          {errors.incentive_type && (
                            <div
                              className="invalid-feedback"
                              style={{ fontSize: "14px" }}
                            >
                              {errors.incentive_type}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label htmlFor="Code" className="form-label">
                            Threshold Limit
                          </label>
                          <input
                            type="text"
                            name="incentive_type"
                            value={formData.incentive_type}
                            className="form-control"
                            onChange={handleInputChange}
                            style={{ padding: "8px 12px", borderRadius: "4px" }}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label htmlFor="Code" className="form-label">
                            Incentive Percentage(%)
                            <span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            name="percent_domestic"
                            value={formData.percent_domestic}
                            onChange={handleInputChange}
                            className={`form-control ${
                              errors.percent_domestic ? "is-invalid" : ""
                            }`}
                            style={{ padding: "8px 12px", borderRadius: "4px" }}
                          />
                          {errors.percent_domestic && (
                            <div
                              className="invalid-feedback"
                              style={{ fontSize: "14px" }}
                            >
                              {errors.percent_domestic}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label htmlFor="Code" className="form-label">
                            From Date<span className="required">*</span>
                          </label>
                          <CustomDatePicker
                            handleChange={(e) => handleInputChange(e)}
                            name="from_date"
                            value={formData.from_date}
                            className={` ${
                              errors.from_date ? "is-invalid" : ""
                            }`}
                            placeholderText="DD-MM-YYYY"
                            style={{ padding: "8px 12px", borderRadius: "4px" }}
                          />
                          {errors.from_date && (
                            <div
                              className="error"
                              style={{ fontSize: "14px", color: "#dc3545" }}
                            >
                              {errors.from_date}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label htmlFor="Code" className="form-label">
                            To Date
                          </label>
                          <CustomDatePicker
                            handleChange={(e) => handleInputChange(e)}
                            name="to_date"
                            value={formData.to_date}
                            className="form-control"
                            placeholderText="DD-MM-YYYY"
                            style={{ padding: "8px 12px", borderRadius: "4px" }}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="col-sm-10 mt-4 pt-2">
                          <Form.Check
                            type="checkbox"
                            name="IsInActive"
                            checked={formData.IsInActive === 1}
                            onChange={handleInputChange}
                            label="Active"
                            style={{ fontSize: "14px" }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12 d-flex justify-content-end mt-4">
                        <button
                          className="cancel-btn me-2"
                          onClick={() => handleEditModalClose()}
                          style={{
                            padding: "6px 16px",
                            borderRadius: "4px",
                            border: "1px solid #6c757d",
                            backgroundColor: "transparent",
                            color: "#6c757d",
                            cursor: "pointer",
                            transition: "all 0.2s",
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className="custom-btn"
                          type="submit"
                          style={{
                            padding: "6px 16px",
                            borderRadius: "4px",
                            border: "1px solid #27568B",
                            backgroundColor: "#27568B",
                            color: "white",
                            cursor: "pointer",
                            transition: "all 0.2s",
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal.Body>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
}

export default IncentiveMaster;
